import React, { useState } from 'react'
import { Status } from '../enum/Status'
import '../index.css';
import * as payoutApi from '../../../apis/withdraw_money_request'
import { formattedDateAndTime } from '../../../utils/customDate';
import { FaUser, FaEnvelope, FaMapMarkerAlt, FaCopy, FaTimes } from 'react-icons/fa';

function RenderTableData({ withdrawdata, index }) {
    const [status, setStatus] = useState(withdrawdata?.status)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [copiedField, setCopiedField] = useState(null);

    // copyToClipboard helper
    const copyToClipboard = (text, fieldName) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedField(fieldName);
            setTimeout(() => setCopiedField(null), 2000);
        });
    };


    // handleApproval
    const handleApproval = async (id) => {
        if (window.confirm("Are you sure you want to approve this withdrawal request?")) {
            try {
                const response = await payoutApi.updatePayoutRequest({
                    id: id,
                    status: Status.APPROVED
                });
                alert(response.message || "Request approved successfully");
                setStatus(Status.APPROVED);
                console.log(`Approving request with ID: ${id}`, response);
            } catch (error) {
                alert(error.response?.data?.message || "Error during approval");
                console.error("Error during approval", error);
            }
        }
    };

    // handleReject
    const handleReject = async (id) => {
        if (window.confirm("Are you sure you want to reject this withdrawal request?")) {
            try {
                const response = await payoutApi.updatePayoutRequest({
                    id: id,
                    status: Status.REJECTED
                });
                alert(response.message || "Request rejected successfully");
                setStatus(Status.REJECTED);
                console.log(`Rejecting request with ID: ${id}`, response);
            } catch (error) {
                alert(error.response?.data?.message || "Error during rejection");
                console.error("Error during rejection", error);
            }
        }
    };

    return (
        <tr key={index}>
            <td>{withdrawdata.id}</td>
            <td>{withdrawdata.user_id}</td>
            <td>{withdrawdata?.user?.username || "N/A"}</td>
            <td>{withdrawdata?.user?.nickname || "N/A"}</td>
            <td>{withdrawdata.paypal_account_id || "N/A"}</td>
            <td>{withdrawdata?.paypal_account?.email || "N/A"}</td>
            <td>
                {withdrawdata?.paypal_account?.firstName + " " + withdrawdata?.paypal_account?.lastName || "N/A"}
            </td>
            <td>$ {withdrawdata.amount_in_dollar || "N/A"}</td>
            <td>{withdrawdata.diamonds_value || "N/A"}</td>
            <td>{formattedDateAndTime(withdrawdata.createdAt) || "N/A"}</td>
            <td>
                <span className={`status-badge status-${status?.toLowerCase()}`}>
                    {status || "N/A"}
                </span>
            </td>
            <td>
                {/* Action Controls */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center' }}>
                    {status === Status.PENDING && (
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                            <button
                                className="withdraw-accept-btn"
                                onClick={() => handleApproval(withdrawdata.id)}>
                                Accept
                            </button>
                            <button
                                className="withdraw-reject-btn"
                                onClick={() => handleReject(withdrawdata.id)}>
                                Reject
                            </button>
                        </div>
                    )}

                    <button
                        className="view-details-btn"
                        onClick={() => setIsModalOpen(true)}>
                        View Account Details
                    </button>
                </div>

                {/* PayPal Details Modal - Premium Redesign */}
                {isModalOpen && (
                    <div className="payout-modal-overlay" onClick={() => setIsModalOpen(false)}>
                        <div className="payout-modal-container" onClick={(e) => e.stopPropagation()}>
                            <div className="payout-modal-header">
                                <h3><FaEnvelope style={{ color: '#3b82f6' }} /> PayPal Account</h3>
                                <button className="payout-close-btn" onClick={() => setIsModalOpen(false)} title="Close">
                                    <span style={{ fontSize: '24px', fontWeight: 'bold', lineHeight: '1' }}>&times;</span>
                                </button>
                            </div>
                            <div className="payout-modal-body">
                                <div className="payout-info-card">
                                    <span className="payout-card-label"><FaUser /> Full Name</span>
                                    <div className="payout-card-value-box">
                                        <span className="payout-card-value">
                                            {withdrawdata?.paypal_account?.firstName} {withdrawdata?.paypal_account?.lastName}
                                        </span>
                                        <button 
                                            className={`payout-copy-btn ${copiedField === 'name' ? 'copied' : ''}`} 
                                            onClick={() => copyToClipboard(`${withdrawdata?.paypal_account?.firstName} ${withdrawdata?.paypal_account?.lastName}`, 'name')}>
                                            <FaCopy /> {copiedField === 'name' ? 'Copied!' : 'Copy'}
                                        </button>
                                    </div>
                                </div>

                                <div className="payout-info-card">
                                    <span className="payout-card-label"><FaEnvelope /> PayPal Email</span>
                                    <div className="payout-card-value-box">
                                        <span className="payout-card-value">{withdrawdata?.paypal_account?.paypalEmail || "N/A"}</span>
                                        {withdrawdata?.paypal_account?.paypalEmail && (
                                            <button 
                                                className={`payout-copy-btn ${copiedField === 'email' ? 'copied' : ''}`} 
                                                onClick={() => copyToClipboard(withdrawdata.paypal_account.paypalEmail, 'email')}>
                                                <FaCopy /> {copiedField === 'email' ? 'Copied!' : 'Copy'}
                                            </button>
                                        )}
                                    </div>
                                </div>

                                <div className="payout-info-card">
                                    <span className="payout-card-label"><FaMapMarkerAlt /> Billing Address</span>
                                    <div className="payout-card-value-box">
                                        <span className="payout-card-value">{withdrawdata?.paypal_account?.billingAddress || "N/A"}</span>
                                        {withdrawdata?.paypal_account?.billingAddress && (
                                            <button 
                                                className={`payout-copy-btn ${copiedField === 'address' ? 'copied' : ''}`} 
                                                onClick={() => copyToClipboard(withdrawdata.paypal_account.billingAddress, 'address')}>
                                                <FaCopy /> {copiedField === 'address' ? 'Copied!' : 'Copy'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </td>
        </tr>
    )
}

export default React.memo(RenderTableData)
